import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const orig = err.config;
    const isAuthCall = orig?.url?.includes("/auth/") || orig?.url?.includes("/admin/");
    if (err.response?.status === 401 && !orig?._retry && !isAuthCall) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        /* refresh failed */
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  return String(d);
}
